import {blank} from "./trim.js";

export function blockQuoteString(content) {
  return blockQuote(content).text;
}

export function blockQuote(content) {
  const [lines, blankLines] = separateByTrailingBlankLines(content.split("\n"));
  const quotesContentLines = lines.map(line => "> " + line);
  const [paddingLines, remainingLines] = takeAtLeastTwo(blankLines);

  return {
    text: [...quotesContentLines, ...paddingLines, ...remainingLines].join("\n"),
    length: [...quotesContentLines, ...paddingLines].join("\n").length
  };
}

function separateByTrailingBlankLines(lines) {
  return splitAt(lines, indexOfLastNonBlankLine(lines));
}

function indexOfLastNonBlankLine(lines) {
  for (let i = lines.length - 1; i >= 0; --i) {
    if (!blank(lines[i])) {
      return i + 1;
    }
  }
  return 0;
}

function takeAtLeastTwo(lines) {
  const [firstTwo, remaining] = splitAt(lines, 2);
  return [padArray(firstTwo), remaining];
}

function splitAt(lines, index) {
  return [lines.slice(0, index), lines.slice(index)];
}

function padArray(array) {
  if (array.length === 0) {
    return ['', ''];
  }
  if (array.length === 1) {
    return [array[0], ''];
  }
  return array;
}
